module.exports = __webpack_public_path__ + "static/media/Muli-Light.7068d37c.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Muli-Light.eot
// module id = 481
// module chunks = 1